// Icons Material can be defined here, not fontAwesome
import HomeIcon from "@material-ui/icons/Home";
import CameraAltIcon from "@material-ui/icons/CameraAlt";

import {
  ActiveUsersByGame,
  PicTreePhotoRanking,
  PicTreeHome,
  PicTreeSalesOverview,
  PicTreeRegistration,
  PicTreeCheckIn,
  PicTreeMap,
  PicTreeReviewSummary,
  PicTreeMapRealTime,
  PicTreePointExchange,
  PicTreeRewardCoin,
  PicTreeRewardedByCoin,
  PicTreeAdImp,
  PicTreeQuizList,
  PicTreeQuizDailyAnswered,
  PicTreeReviewAppearance,
  PicTreeTreasureChest,
  PicTreeRainbowDetail,
  PicTreeTepcoHome,
  PicTreeReviewByAssetTypeTepco,
  PicTreeMissionSummary,
  PicTreeMissionRanking,
  PicTreeReviewSummaryNtt,
  PicTreeReportSummaryNtt,
  PicTreeCheckInNtt,
  PicTreeMapNtt,
  PicTreeUserList,
  PicTreePointExHistory,
  PicTreeReportSummary,
  PicTreeReportTsuruSummary,
  PicTreeReviewByAssetTypeNtt,
  PicTreeMapRealTimeNtt,
  PicTreeReviewSummaryHokuden,
  PicTreeReviewByAssetTypeHokuden,
  PicTreeGroupSummaryHokuden,
  PicTreeMapRealTimeHokuden,
  PicTreeMapHokuden,
  PicTreeCheckInHokuden,
  PicTreeReportSummaryHokuden,
  PicTreeFirstPhotoRanking,
  PicTreeSeasonRanking,
  PicTreeAreaRanking,
} from "pages";

export default {
  items: [
    {
      path: "/game/pictree/all",
      name: "PicTrée 全体",
      type: "submenu",
      icon: CameraAltIcon,
      component: null,
      sideBar: true,
      children: [
        {
          path: "/home",
          name: "ホーム",
          type: "link",
          icon: HomeIcon,
          component: PicTreeHome,
          sideBar: true,
          divider: true,
        },
        {
          path: "/registration",
          name: "集客",
          type: "link",
          icon: false,
          component: PicTreeRegistration,
          sideBar: true,
          divider: false,
        },
        {
          path: "/users",
          name: "登録ユーザー",
          type: "link",
          icon: false,
          component: PicTreeUserList,
          sideBar: true,
          divider: false,
        },
        {
          path: "/active-users",
          name: "アクティブユーザー",
          icon: null,
          component: ActiveUsersByGame,
        },
        {
          path: "/ranking",
          name: "ランキング",
          type: "submenu",
          sideBar: true,
          children: [
            {
              path: "/photo-ranking",
              name: "撮影",
              icon: null,
              component: PicTreePhotoRanking,
            },
            {
              path: "/first-photo-ranking",
              name: "初回撮影",
              icon: null,
              component: PicTreeFirstPhotoRanking,
            },
            {
              path: "/season-ranking",
              name: "シーズン",
              icon: null,
              component: PicTreeSeasonRanking,
            },
            {
              path: "/area-ranking",
              name: "エリア別",
              icon: null,
              component: PicTreeAreaRanking,
            },
          ],
        },
        {
          path: "/sales",
          name: "売上概要",
          type: "link",
          icon: false,
          category: "課金・報酬",
          component: PicTreeSalesOverview,
          sideBar: true,
          divider: false,
        },
        {
          path: "/reward-coin",
          name: "報酬コイン",
          type: "submenu",
          sideBar: true,
          children: [
            {
              path: "/ranking",
              name: "獲得ランキング",
              icon: null,
              component: PicTreeRewardCoin,
            },
            {
              path: "/count-by-coin",
              name: "撮影報酬排出",
              icon: null,
              component: PicTreeRewardedByCoin,
            },
          ],
        },
        {
          path: "/treasure-chest",
          name: "宝箱",
          type: "submenu",
          sideBar: true,
          children: [
            {
              path: "/daily-count",
              name: "日別排出件数",
              icon: null,
              component: PicTreeTreasureChest,
            },
            {
              path: "/rainbow-list",
              name: "レインボー排出一覧",
              icon: null,
              component: PicTreeRainbowDetail,
            },
          ],
        },
        {
          path: "/point",
          name: "ポイント交換",
          type: "link",
          icon: false,
          component: PicTreePointExchange,
          sideBar: true,
          divider: false,
        },
        {
          path: "/point-exchange-history",
          name: "ポイント交換履歴",
          type: "submenu",
          sideBar: true,
          children: [
            {
              path: "/goods",
              name: "グッズ交換履歴",
              icon: null,
              component: PicTreePointExHistory,
            },
          ],
        },
        {
          path: "/ad/banner",
          name: "バナー広告",
          type: "link",
          icon: false,
          category: "広告",
          component: PicTreeAdImp,
          sideBar: true,
          divider: false,
        },
        {
          path: "/ad/quiz",
          name: "クイズ広告",
          type: "link",
          icon: false,
          component: PicTreeQuizList,
          sideBar: true,
          divider: false,
        },
        {
          path: "/ad/quiz/answered",
          name: "クイズ別回答者数",
          type: "link",
          icon: false,
          component: PicTreeQuizDailyAnswered,
          sideBar: true,
          divider: false,
        },
      ]
    },
    {
      path: "/game/pictree/tepco",
      name: "PicTrée TEPCO",
      type: "submenu",
      icon: CameraAltIcon,
      component: null,
      sideBar: true,
      children: [
        {
          path: "/home",
          name: "ホーム",
          type: "link",
          icon: HomeIcon,
          component: PicTreeTepcoHome,
          sideBar: true,
          divider: true,
        },
        {
          path: "/checkin",
          name: "チェックイン",
          type: "link",
          icon: false,
          component: PicTreeCheckIn,
          sideBar: true,
          divider: false,
        },
        {
          path: "/photos",
          name: "通常モード",
          type: "submenu",
          category: "撮影",
          sideBar: true,
          children: [
            {
              path: "/overview",
              name: "概要",
              icon: null,
              component: PicTreeReviewSummary,
            },
            {
              path: "/asset-type",
              name: "アセットタイプ別",
              type: "link",
              icon: false,
              component: PicTreeReviewByAssetTypeTepco,
              sideBar: true,
              divider: true,
            },
            {
              path: "/realtime",
              name: "リアルタイム",
              icon: null,
              component: PicTreeMapRealTime,
              new: false,
            },
            {
              path: "/map",
              name: "地図表示",
              icon: null,
              component: PicTreeMap,
            },
          ]
        },
        {
          path: "/mission",
          name: "ミッションモード",
          type: "submenu",
          sideBar: true,
          children: [
            {
              path: "/overview",
              name: "概要",
              icon: null,
              component: PicTreeMissionSummary,
            },
            {
              path: "/ranking",
              name: "達成ランキング",
              icon: null,
              component: PicTreeMissionRanking,
            },
          ],
        },
        {
          path: "/report",
          name: "報告モード",
          type: "submenu",
          sideBar: true,
          children: [
            {
              path: "/overview",
              name: "概要",
              icon: null,
              component: PicTreeReportSummary,
            },
            {
              path: "/plant",
              name: "ツルツタ報告",
              icon: null,
              component: PicTreeReportTsuruSummary,
            },
          ],
        },
      ],
      divider: false,
    },
    {
      path: "/game/pictree/ntt",
      name: "PicTrée NTT",
      type: "submenu",
      icon: CameraAltIcon,
      component: null,
      sideBar: true,
      children: [
        {
          path: "/photos/overview",
          name: "概要",
          type: "link",
          icon: false,
          category: "撮影",
          component: PicTreeReviewSummaryNtt,
          sideBar: true,
          divider: true,
        },
        {
          path: "/photos/asset-type",
          name: "アセットタイプ別",
          type: "link",
          icon: false,
          component: PicTreeReviewByAssetTypeNtt,
          sideBar: true,
          divider: true,
        },
        {
          path: "/photos/realtime",
          name: "リアルタイム",
          icon: null,
          component: PicTreeMapRealTimeNtt,
          new: false,
        },
        {
          path: "/photos/map",
          name: "地図表示",
          type: "link",
          icon: false,
          component: PicTreeMapNtt,
          sideBar: true,
          divider: false,
        },
        {
          path: "/checkin",
          name: "チェックイン",
          type: "link",
          icon: false,
          component: PicTreeCheckInNtt,
          sideBar: true,
          divider: false,
        },
        {
          path: "/report/overview",
          name: "概要",
          type: "link",
          icon: false,
          category: "報告",
          component: PicTreeReportSummaryNtt,
          sideBar: true,
          divider: true,
        },
      ]
    },
    {
      path: "/game/pictree/hokuden",
      name: "PicTrée ほくでん",
      type: "submenu",
      icon: CameraAltIcon,
      component: null,
      sideBar: true,
      children: [
        {
          path: "/photos/group",
          name: "グループ登録",
          type: "link",
          icon: false,
          component: PicTreeGroupSummaryHokuden,
          sideBar: true,
          divider: true,
        },
        {
          path: "/photos/overview",
          name: "概要",
          type: "link",
          icon: false,
          category: "撮影",
          component: PicTreeReviewSummaryHokuden,
          sideBar: true,
          divider: true,
        },
        {
          path: "/photos/asset-type",
          name: "アセットタイプ別",
          type: "link",
          icon: false,
          component: PicTreeReviewByAssetTypeHokuden,
          sideBar: true,
          divider: true,
        },
        {
          path: "/photos/realtime",
          name: "リアルタイム",
          icon: null,
          component: PicTreeMapRealTimeHokuden,
          new: false,
        },
        {
          path: "/photos/map",
          name: "地図表示",
          type: "link",
          icon: false,
          component: PicTreeMapHokuden,
          sideBar: true,
          divider: false,
        },
        {
          path: "/checkin",
          name: "チェックイン",
          type: "link",
          icon: false,
          component: PicTreeCheckInHokuden,
          sideBar: true,
          divider: false,
        },
        {
          path: "/report/overview",
          name: "概要",
          type: "link",
          icon: false,
          category: "報告",
          component: PicTreeReportSummaryHokuden,
          sideBar: true,
          divider: true,
        },
      ]
    },
  ],
};
